const certificationTimeline = [
  {
    name: "Financial Education Training",
    issueOrganization: "Bank of Georgia",
    desc: " - Building practical financial literacy skills across budgeting, saving, credit, investing, and everyday money management.",
    issueDate: "Feb 2026",
    link: "https://media.licdn.com/dms/image/v2/D4D2DAQE2bHpYyxsjmQ/profile-treasury-image-shrink_800_800/B4DZ1dQR_8JQAY-/0/1775386043573?e=1781521200&v=beta&t=ajj30Wsck50RQLc8mclsvAiypT5YE7I79gxHdqvAvFE",
  },
  {
    name: "Data Scientist",
    issueOrganization: "DataCamp",
    desc: " - Developing Python based data workflows for cleaning, analysis, visualization, modeling, and deployment with modern data science tools.",
    issueDate: "Feb 2026",
    link: "https://www.datacamp.com/certificate/DS0020766177709",
  },
  {
    name: "AI Engineer for Data Scientists Associate",
    issueOrganization: "DataCamp",
    desc: " - Developing Python pipelines for data management, exploratory data analysis, model development, ethical AI compliance, and data science programming, integrating REST APIs, Docker, Kubernetes, and CI/CD.",
    issueDate: "Jun 2025",
    link: "https://www.datacamp.com/certificate/AEDS0017038047645",
  },
  {
    name: "GitHub Foundations",
    issueOrganization: "GitHub",
    desc: " - Mastering Git and GitHub fundamentals, repository workflows, collaboration features, modern development practices, project management, privacy and security administration, and GitHub community benefits.",
    issueDate: "Jun 2025",
    link: "https://www.credly.com/badges/ccf37b2b-bc27-4a36-b85e-871844c64211/",
  },
  {
    name: "Global Growth Digital Design Accelerator",
    issueOrganization: "Georgian National University SEU",
    desc: " - Strengthening digital design and growth skills through branding, visual storytelling, user focused content, and marketing oriented creative execution.",
    issueDate: "Apr 2025",
    link: "https://media.licdn.com/dms/image/v2/D4D2DAQG-Gh2KYBFAcw/profile-treasury-document-cover-images_1280/B4DZdy.KXXGkA8-/0/1749980595111?e=1781521200&v=beta&t=8VO12sxiM3bWd-zoCLn8-eKKQqiKrx8LItjSva0dfiY",
  },
  {
    name: "100 Days of Code: The Complete Python Pro Bootcamp",
    issueOrganization: "Udemy",
    desc: " - Building Flask web apps, integrating AI in finance, analyzing data with NumPy/Pandas, creating Plotly visualizations, managing PostgreSQL, and deploying Scikit-Learn models.",
    issueDate: "Apr 2025",
    link: "https://www.udemy.com/certificate/UC-28c5b193-13af-4102-b7f9-7bfc6208a17e/",
  },
  {
    name: "AWS Knowledge: Serverless",
    issueOrganization: "Amazon",
    desc: " - Designing and deploying serverless applications on AWS, leveraging API Gateway, Lambda, and other cloud native services.",
    issueDate: "Sep 2024",
    link: "https://www.credly.com/badges/867bb136-e055-4ea8-a27c-786f51007a55/",
  },
  {
    name: "IT Specialist - Software Development",
    issueOrganization: "Certiport",
    desc: " - Applications, from desktop to web, are built with core programming and object oriented design, supported by scalable and reliable database systems.",
    issueDate: "Apr 2023",
    link: "https://www.credly.com/badges/42993002-c59e-400f-8bcd-716c1b43dc74/",
  },
];

export default certificationTimeline;